<template>
  <b-modal :active.sync="isModalActive" :width="720" scroll="keep">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <form @submit.prevent="saveExtraField" class="w-full">
        <!-- HEADER sin fondo gris -->
        <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
          <div class="flex-1 min-w-0">
            <h2 class="break-words whitespace-normal">
              Progreso de Avance del grupo de actividad {{ data ? data.name : ''  }}
            </h2>
          </div>
          <div class="flex-shrink-0">
            <b-dropdown aria-role="list" position="is-bottom-left">
              <template #trigger="{ active }">
                  <b-button
                      label="Acciones"
                      type="is-primary"
                      icon-pack="fas"
                      size="is-small"
                      :icon-right="active ? 'chevron-up' : 'chevron-down'" />
              </template>
              <b-dropdown-item aria-role="listitem" @click="handleClickAction('scheduled')">Recalcular progreso programado</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="handleClickAction('inspected')">Recalcular progreso inspeccionado</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="handleClickAction('all')">Recalcular todo</b-dropdown-item>
            </b-dropdown>
          </div>
        </header>

        <!-- BODY con fondo blanco liso -->
        <div class="px-6 py-5 space-y-4 bg-white">

          <div class="w-full flex gap-4">

            <div class="flex-1 w-2/3">
              <b-field :label="$t('type')" custom-class="text-blue font-medium">
                <b-select
                  v-model="form.filter_type"
                  :placeholder="$t('select')"
                  expanded
                  @input="handleSelectTypeInput"
                >
                  <option v-for="option in options" :value="option.value" :key="'type_'+option.value">
                    {{ option.text }}
                  </option>
                </b-select>
              </b-field>
              <!-- <label form="type" class="text-blue font-medium">{{ $t('type')}}</label> -->
            </div>

            <div class="flex-1 w-2/3">
              <b-field :label="$t('start_date')" custom-class="text-blue font-medium">
                <b-datepicker v-if="form.filter_type == 1"
                  v-model="form.filter_date"
                  type="month"
                  placeholder="Click to select..."
                  icon-pack="fas"
                  icon="calendar"
                  trap-focus
                  @input="handleDateInput"
                >
                </b-datepicker>
                <b-datepicker v-else
                  v-model="form.filter_date"
                  placeholder="Click to select..."
                  icon-pack="fas"
                  icon="calendar-alt"
                  :icon-right="form.filter_date ? 'close-circle' : ''"
                  icon-right-clickable
                  @icon-right-click="clearDate"
                  @input="handleDateInput"
                  trap-focus
                  :disabled="form.filter_type != 2"
                >
                </b-datepicker>
              </b-field>
            </div>
          </div>

          <div class="pb-4 border-b border-[#E4E6EB] border-grey-light">
            <!-- Contenido dinámico -->
            <div class="flex flex-row w-full">
              <line-chart :min="dataset.min"
                          :max="dataset.max"
                          :suffix="dataset.suffix"
                          :data="dataset.data"
                          :library="chartOptions"
                          />
            </div>
          </div>
        </div>

        <!-- FOOTER sin fondo gris, solo borde superior -->
        <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
          <div class="w-full flex justify-end space-x-2">
            <button
              type="button"
              class="px-4 py-2 bg-gray-50 rounded-md text-gray-700 hover:bg-gray-100 transition"
              @click="isModalActive = false"
            >
              Cerrar
            </button>
            <!-- <button
              type="submit"
              class="px-5 py-2 bg-[#1877F2] bg-blue-light text-white text-sm font-medium rounded-md hover:bg-[#166FE5] hover:bg-blue-700 transition"
            >
              {{ $t('save') }}
            </button> -->
          </div>
        </footer>
      </form>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "activity-group-chart-modal",

  components: {},

  data: () => ({
    isModalActive: false,
    isLoading: false,
    data: null,
    form: {
      filter_type: 0,
      filter_month: "",
      filter_date: null,
    },
    dataset: {
      min: 0,
      max: 100,
      suffix: '%',
      data: []
    },
    months: [],
    options: [
      { value: 0, text: 'Por defecto' },
      { value: 1, text: 'Mes' },
      { value: 2, text: 'Fecha' },
    ],

    chartOptions: {
      spanGaps: true,
      scales: {
        x: {
          beginAtZero: true,
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'yyyy.MM',
            }
          },
          ticks: {
            source: 'data',
            autoSkip: false,
          }
        }
      }
    }
  }),

  computed: {
    datePickerType() {
      if (this.form.filter_type === 1) return 'month';
      return 'date';
    }
  },

  methods: {
    async fetchActivityGroupProgress(params={}) {
      this.isLoading = true;
      let url = "/api/v2/activity-groups/"+this.data.id+"/progress-dataset";

      axios({
        method: "get",
        url: url,
        params: params
      })
        .then(response => {
          if (response.data.error) {
            this.$toast.open({
              message: response.data.error,
              type: "is-danger",
              position: "is-top-right"
            });
          }

          this.dataset.min = response.data?.min ?? 0;
          this.dataset.max = response.data?.max ?? 100;
          this.dataset.suffix = response.data?.suffix ?? '%';
          this.dataset.data = response.data?.datasets ?? [];

          this.isLoading = false;
        })
        .catch(error => {
          //Se produjo un error
          this.isLoading = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("save_error"),
            type: "is-danger",
            position: "is-top-right"
          });

          this.isLoading = false;
        });
    },

    handleDateInput(date) {

      // console.log("Selected date:", date);
      const year = date.getFullYear(); // 2025
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 02
      const day = String(date.getDate()).padStart(2, '0'); // 01 (si fuera necesario)

      const formatted = `${year}-${month}-${day}`; // Formato: YYYY.MM.DD
      // console.log("Selected date:", formatted);

      let params = {
        filter_type: this.form.filter_type === 1 ? 'month' : 'date', // 1 para mes, 2 para fecha
        filter_date: formatted,
      };

      this.fetchActivityGroupProgress(params);
    },

    handleSelectTypeInput(value) {
      if( value === 0) {
        this.form.filter_type = value;
        this.form.filter_date = null; // Reset date when type changes
        this.fetchActivityGroupProgress({filter_type: 'default'});
      }
    },

    clearDate () {
      this.form.filter_date = null;
    },

    handleClickAction(value) {
      this.isLoading = true;
      let url = "/api/v2/activity-groups/"+this.data.id+"/chart-data/recalculate";

      axios({
        method: "get",
        url: url,
        params: {
          type: value,
        }
      })
        .then(response => {
          this.$toast.open({
            message: this.$t("save_successful"),
            type: "is-success",
            position: "is-top-right"
          });

          this.dataset.min = response.data?.min ?? 0;
          this.dataset.max = response.data?.max ?? 100;
          this.dataset.suffix = response.data?.suffix ?? '%';
          this.dataset.data = response.data?.datasets ?? [];

          this.isLoading = false;
        })
        .catch(error => {
          //Se produjo un error
          this.isLoading = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("save_error"),
            type: "is-danger",
            position: "is-top-right"
          });

          this.isLoading = false;
        });
    },

    show(data) {
      this.data = data;
      this.form.filter_month = "";
      this.form.filter_date = null;
      this.field_type = 0;
      this.dataset.data = [];
      this.fetchActivityGroupProgress({filter_type: 'default'});
      this.isModalActive = true;
    },

    hide() {
      this.data = null;
      this.isModalActive = false;
      this.form.filter_month = "";
      this.form.filter_date = null;
      this.field_type = 0;
      this.dataset.data = [];
    }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
